import type { KeyboardEvent } from "react";

const selector = 'input[type="text"][data-m1-measurement]';
const measurement = (target: EventTarget | null): target is HTMLInputElement =>
	target instanceof HTMLInputElement && target.matches(selector);

/** Attach to the existing form. Only marked measurements participate, in DOM order. */
export function useMeasurementNavigation() {
	return {
		formHandlers: {
			onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
				if (
					event.defaultPrevented ||
					![
						"Enter",
						"ArrowDown",
						"ArrowUp",
						"ArrowLeft",
						"ArrowRight",
					].includes(event.key) ||
					event.altKey ||
					event.ctrlKey ||
					event.metaKey ||
					event.shiftKey ||
					event.nativeEvent.isComposing
				)
					return;
				const target = event.target;
				if (
					!measurement(target) ||
					target.matches(":disabled") ||
					target.readOnly
				)
					return;
				const horizontal =
					event.key === "ArrowLeft" || event.key === "ArrowRight";
				if (
					horizontal &&
					(target.selectionStart === null ||
						target.selectionEnd === null ||
						target.selectionStart !== target.selectionEnd ||
						target.selectionStart !==
							(event.key === "ArrowLeft" ? 0 : target.value.length))
				)
					return;
				event.preventDefault();
				const inputs = [
					...event.currentTarget.querySelectorAll<HTMLInputElement>(selector),
				].filter((input) => !input.matches(":disabled") && !input.readOnly);
				const index = inputs.indexOf(target);
				if (index >= 0)
					inputs[
						index +
							(event.key === "ArrowUp" || event.key === "ArrowLeft" ? -1 : 1)
					]?.focus();
			},
		},
	};
}
